export default __webpack_public_path__ + "static/media/icon-tips.2cf9b6c2.png";